export default {
  version: '2.4.0.0',
};
